import { initializeSyncfusion } from "@/integrations/syncfusion";
import { initializeBugsnag } from "@/integrations/bugsnag";

export default function init() {
  initializeSyncfusion();
  initializeBugsnag();
}
